/**
 * vue2-helpers@2.1.1
 * A util package to use Vue 2 with Composition API easily
 * @author Ambit Tsai <ambit_tsai@qq.com>
 * @license Apache-2.0
 * @see {@link https://github.com/ambit-tsai/vue2-helpers#readme}
 */
import o,{getCurrentInstance as n}from"vue";import e,{Store as r}from"vuex";var t=console.warn;function u(n){return o.use(e),new r(n)}function i(){var o=n();if(o)return o.proxy.$store;t("method can only be used inside setup() or functional components")}export{u as createStore,i as useStore};
//# sourceMappingURL=vuex.js.map
